import React, { ReactElement, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { IParentProps } from '../../shared/types/IParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { createLayoutSlot } from '../layout-slot/createLayoutSlot';
import { useSlot } from '../layout-slot/useSlot';

import { OzModalContent } from './ModalContent';
import { OzModalProvider } from './ModalContext';
import { OzModalOverlay } from './ModalOverlay';

type IModalProps = IParentProps & IQATestableProps & {
    isOpen: boolean;
    showMask?: boolean;
    hideModal: () => void;
};

enum MODAL_SLOTS {
    BODY,
    ACTIONS,
}

export function OzModal (props: IModalProps): ReactElement | null {
    const { isOpen, hideModal, children, showMask = true }: IModalProps = props;
    const bodySlot: ReactNode = useSlot(children, MODAL_SLOTS.BODY);
    const actionsSlot: ReactNode = useSlot(children, MODAL_SLOTS.ACTIONS);

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <OzModalProvider hideModal={hideModal}>
            {showMask && <OzModalOverlay />}
            <OzModalContent data-testid="OzModalContent">
                <div className="font-gellix text-base text-gray-900">{bodySlot}</div>
                {actionsSlot && <div className="flex gap-3 justify-start pt-3">{actionsSlot}</div>}
            </OzModalContent>
        </OzModalProvider>,
        document.body,
    );
}

OzModal.Body = createLayoutSlot(MODAL_SLOTS.BODY, 'OzModal.Body');
OzModal.Actions = createLayoutSlot(MODAL_SLOTS.ACTIONS, 'OzModal.Actions');
